import { transformAsCurrency } from '~/utils/functions';

type SubtotalResult = {
  rendeKg: number;
  totQtdProducao: number;
  custoProducao: number;
  custoFinalProducao: number;
  custoSemImp: number;
  custoReceita: number;
  totQtdReceita: number;
};

type SubtotalParams = {
  itens: Item[];
  perDespesaProducao: number;
};

type Item = {
  qtd_producao: number;
  qtd_receita: number;
  val_custo_rep: number;
  val_custo_sem_icms: number;
  custoSemImpostoFinal: number;
  custoFinal: number;
};

export function calculaSubTotal({
  itens,
  perDespesaProducao,
}: SubtotalParams): SubtotalResult {
  const {
    rendeKg,
    totalQtdProducao,
    totalCustoReceita,
    custoProducao,
    totalCustoSemImposto,
    totalQtdReceita,
  } = itens.reduce(
    (acc, item) => {
      return {
        custoProducao: acc.custoProducao + item.custoFinal,
        totalCustoSemImposto:
          acc.totalCustoSemImposto + item.custoSemImpostoFinal,
        totalCustoReceita:
          acc.totalCustoReceita + item.custoFinal * item.qtd_receita,
        rendeKg: acc.rendeKg + item.qtd_producao,
        totalQtdProducao: acc.totalQtdProducao + item.qtd_producao,
        totalQtdReceita: acc.totalQtdReceita + item.qtd_receita,
      };
    },
    {
      rendeKg: 0,
      totalQtdProducao: 0,
      totalCustoReceita: 0,
      totalCustoSemImposto: 0,
      custoProducao: 0,
      totalQtdReceita: 0,
    },
  );
  const custoFinalProducao = transformAsCurrency(
    totalCustoReceita + (perDespesaProducao / 100) * totalCustoReceita,
  );
  return {
    rendeKg,
    custoFinalProducao,
    custoSemImp: totalCustoSemImposto,
    custoReceita: totalCustoReceita,
    custoProducao,
    totQtdProducao: totalQtdProducao,
    totQtdReceita: totalQtdReceita,
  };
}
